//import AppStoreConnectDataAccess from "./AppStoreConnectDataAccess";
import {ArrayUtil} from "oca-lib-web";
import DashboardDateUtil from "../util/DashboardDateUtil";
import moment from "moment";
import EventUtil from "../util/EventUtil";
//import { getGlobal } from 'reactn';
//import GoogleAnalyticsDataAccess from "./GoogleAnalyticsDataAccess";
import FlurryDataAccess from "./FlurryDataAccess";
import Constants from "../util/Constants";
//import TwitterDataAccess from "./TwitterDataAccess";
import BaseDataSource from "./BaseDataSource";

export default class AnalyticsEngine {

    public static getDataset(item:GraphSettings, timeInterval:TimeInterval):Array<number> {
        let data = this.getData(item, timeInterval);

        if (item.chartType == Constants.CHART_TYPE_SUMMARY) {
            return data;
        }
        let dataset = this.populateDataset(item, data, timeInterval);
        //console.log(dataset);

        if (item.sortOrder && item.sortOrder !== "none") {
            ArrayUtil.sortForInt(dataset, item.metric, item.sortOrder === "ascending");
        }
        if (item.rank) {
            dataset = dataset.slice(0, item.rank);
        }

        return dataset;
    }

    // TODO: Make private so that everything goes through getDataset
    public static getData(item:GraphSettings, timeInterval:TimeInterval):Array<any> {
        let data:Array<any> = [];
        data = BaseDataSource.getDataForDataSource(item.dataSource);
        if (data) {
            data = ArrayUtil.filter(data, function (item: any) {
                if (!item.date) {
                    return false;
                }
                //if (!item.data) { return true; }
                return item.date >= timeInterval.start && item.date <= timeInterval.end;
            });
            data = this.applyFilters(item, data);
        }

        return data;
    }

    public static getUniqueDataValues(item:GraphSettings, paramName:string) {
        let graphParamValues:Array<string> = [];
        let dataset:Array<any> = this.getData(item, DashboardDateUtil.getTimeInterval());

        for (let dataItem of dataset) {
            let paramValue;
            if (EventUtil.hasParam(dataItem, paramName)) {
                paramValue = EventUtil.getParamValue(dataItem, paramName);
            } else {
                paramValue = dataItem[paramName];
            }
            if (!ArrayUtil.contains(graphParamValues, paramValue)) {
                graphParamValues.push(paramValue);
            }
        }
        return graphParamValues;
    }

    // Private methods

    public static populateDataset(item:GraphSettings, dataset:Array<any>, timeInterval:TimeInterval) {
        if (!dataset) {
            return [];
        }
        let newDataset:Array<any> = null;
        if (item.xAxis == "date") {
            newDataset = this.createEmptyTimeDataset(item, timeInterval);
        } else {
            newDataset = this.createEmptyDataset(item, timeInterval, dataset);
        }

        for (let dataItem of dataset) {
            for (let newDataItem of newDataset) {
                let xAxis = item.xAxis;
                let dataItemAxisValue = this.getAxisValue(xAxis, dataItem);
                if (dataItemAxisValue == newDataItem[xAxis] && (!item.group || dataItem[item.group] == newDataItem[item.group])) {
                    let metrics = item.metric.split(",");
                    for (let metricItem of metrics) {
                        if (!newDataItem[metricItem]) {
                            newDataItem[metricItem] = 0;
                        }
                        newDataItem[metricItem] += parseInt(dataItem[metricItem]);
                    }
                }
            }
        }
        return newDataset;
    }

    private static createEmptyDataset(item:GraphSettings, timeInterval:TimeInterval, data:Array<any>): Array<any> {
        /*if (item.xAxis == "date") {
            return this.createEmptyTimeDataset(item, timeInterval);
        }*/

        let dataset:Array<any> = [];
        for (let dataItem of data) {
            let found = false;
            let dataItemAxisValue = this.getAxisValue(item.xAxis, dataItem);
            for (let datasetItem of dataset) {
                if (datasetItem[item.xAxis] == dataItemAxisValue) { found = true; }
            }
            if (!found && dataItemAxisValue) {
                let newDatasetItem = {};
                newDatasetItem[item.xAxis] = dataItemAxisValue;
                dataset.push(newDatasetItem);
            }
        }
        return dataset;
    }

    private static createEmptyTimeDataset(item:GraphSettings, timeInterval:TimeInterval): Array<any> {
        let timeDataset:Array<any> = [];
        let dates = DashboardDateUtil.getDatesForFormat(timeInterval, "YYYYMMDD");

        for (var i=0; i<dates.length; i++) {
            let unitDateMoment;
            let dateInterval = DashboardDateUtil.getDateInterval(timeInterval.interval);
            if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
                unitDateMoment = moment(timeInterval.start).add(i, 'months');
            } else if (dateInterval == Constants.DATE_INTERVAL_DAY) {
                unitDateMoment = moment(timeInterval.start).add(i, 'days');
            }

            if (item.group) {
                let groupValues = this.getUniqueDataValues(item, item.group);
                for (let groupValue of groupValues) {
                    let dataset = this.createEmptyTimeDataItem(unitDateMoment, item.metric);
                    dataset[item.group] = groupValue;
                    timeDataset.push(dataset);
                }
            } else {
                /*let metrics = item.metric.split(",");
                for (let metric of metrics) {
                    let dataset = this.createEmptyTimeDataItem(unitDateMoment, metric);
                    dataset[metric] = metric;
                    timeDataset.push(dataset);
                }*/
                timeDataset.push(this.createEmptyTimeDataItem(unitDateMoment, item.metric));
            }
        }
        return timeDataset;
    }

    private static createEmptyTimeDataItem(unitDateMoment:any, metric:string):any {
        //let unitDateMoment = moment(timeInterval.start).add(i, 'days');
        let unitDateString = unitDateMoment.format("YYYYMMDD");
        let timeDatasetItem = {};
        timeDatasetItem["date"] = unitDateString;
        let metrics = metric.split(",");
        for (let metricItem of metrics) {
            timeDatasetItem[metricItem] = 0;
        }
        return timeDatasetItem;
    }

    private static applyFilters(item:GraphSettings, dataset:Array<any>):Array<any> {
        let filteredData:Array<any> = dataset;
        if (!item.filters) { return filteredData }

        for (let filter of item.filters) {
            let selectionValueList = filter.isCustom ? filter.selectionValuesCustom.split(",") : filter.selectionValues.split(",");
            filteredData = filteredData.filter(function(dataItem) {
                let paramValue;
                if ((item.dataSource == FlurryDataAccess.EVENTPARAMS) && EventUtil.hasParam(dataItem, filter.selectionName)) {
                    paramValue = EventUtil.getParamValue(dataItem, filter.selectionName);
                } else {
                    paramValue = dataItem[filter.selectionName];
                }
                for (let selectionValue of selectionValueList) {
                    if (paramValue == selectionValue) {
                        return true;
                    }
                }
                return false;
            });
        }
        return filteredData;
    }

    private static getAxisValue(xAxis:string, dataItem:any) {
        if (EventUtil.hasParam(dataItem, xAxis)) {
            return EventUtil.getParamValue(dataItem, xAxis);
        } else {
            return dataItem[xAxis];
        }
    }
}